export default __webpack_public_path__ + "static/dei-n3-d6ef4eab798ee23c17d9804af1d4ef28.svg";